import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { ClienteService } from './../../../../services/cliente.service'

@Component({
  selector: 'app-detalle-cliente',
  templateUrl: './detalle-cliente.component.html',
  styleUrls: ['./detalle-cliente.component.scss']
})
export class detalleContenidoComponent implements OnInit {

  disableInputBox =  true;
  detalleContenido: any = {}
  public cliente: any;
  public path: any;

  constructor(@Inject(MAT_DIALOG_DATA) public info: {
      id: string,
      refreshTabla: any
    }, private formBuilder: FormBuilder, private apollo: Apollo, private clienteService: ClienteService, private router: Router) { 
    this.path = this.router.url
  }

  ngOnInit(): void {
    this.formBuild()
    this.getClienteById();
  }

  private formBuild(){
    this.detalleContenido = this.formBuilder.group({
      razonSocial: [''],
      cif: [''],
      nombreComercial: [''],
      domicilio: this.formBuilder.group({
        via: [''],
        nombreVia: [''],
        provincia: [''],
        ccaa: [''],
        codigoPostal: ['']
      }),
      contacto: this.formBuilder.group({
        contactoNombre: [''],
        contactoMail: [''],
        cargo: [''],
      }),
      actividad: [''],
      motivoAlta: ['']
    })
  }

  getClienteById(): void{  
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        id: this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.cliente = data.cliente
        this.displayCliente()
      })
  }

  disableInput(): void {
    this.disableInputBox = !this.disableInputBox;
  }

  displayCliente(){
    if(this.detalleContenido){
      this.detalleContenido.reset()
    }
    console.log('Display', this.cliente)
    this.detalleContenido.patchValue({
      razonSocial: this.cliente.razonSocial,
      cif: this.cliente.cif,
      nombreComercial: this.cliente.nombreComercial,
      domicilio: {
        via: this.cliente.domicilio?.tipoVia,
        nombreVia: this.cliente.domicilio?.nombre,
        provincia: this.cliente.domicilio?.provincia,
        ccaa: this.cliente.domicilio?.ccaa,
        codigoPostal: this.cliente.domicilio?.codigoPostal
      },
      actividad: this.cliente.actividad,
      motivoAlta: this.cliente.motivoAlta,
      contacto: {
        contactoMail: this.cliente.contactoResponsable?.mail,
        contactoNombre: this.cliente.contactoResponsable?.nombre,
        cargo: this.cliente.contactoResponsable?.cargo
      },
    })
  }

  updateClienteById(){
    this.cliente = {...this.cliente, ...this.detalleContenido.value}
    console.log('update',this.cliente)
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": this.info.id
          },
          "data": {
            "razonSocial": this.cliente.razonSocial,
            "nombreComercial": this.cliente.nombreComercial,
            "cif": this.cliente.cif,
            "domicilio": {
              "tipoVia": this.cliente.domicilio?.via,
              "nombre": this.cliente.domicilio?.nombreVia,
              "provincia": this.cliente.domicilio?.provincia,
              "ccaa": this.cliente.domicilio?.ccaa,
              "codigoPostal": this.cliente.domicilio?.codigoPostal
            },
            "actividad": this.cliente.actividad,
            "contactoResponsable": {
              "mail": this.cliente.contacto.contactoMail,
              "nombre": this.cliente.contacto.contactoNombre,
              "cargo": this.cliente.contacto.cargo,
            }
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
        location.reload()
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  setIdCliente(id: string){
    this.clienteService.setIdCliente(id)
    console.log(id);
    
    
  }

}
